import React from 'react';
import Card from '../components/Card';
import experienceImg from '../utils/images/experience.jpg';

const Experience = () => {
    return (
        <Card icon="💻" title="MY EXPERIENCE!" image={experienceImg}>
            <ul className="pl-8 space-y-5 text-lg tracking-wider text-left list-decimal list-outside lg:space-y-8">
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://stratzy.in/"
                        style={{ borderBottomWidth: 0.5 }}
                        className="font-semibold transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        Stratzy
                    </a>

                    <p className="mt-3 text-base tracking-normal lg:mt-6">
                        <span className="font-bold">Tenure: </span>
                        Aug '22 - Present
                        <br />
                        <span className="font-bold">Role: </span>
                        Web Lead
                        <br />
                        <span className="font-bold">Tech Stack: </span>
                        MERN - MongoDB, Express, React, Node
                        <p className="mt-3">
                            Working on the payments, a B2B Saas Product -
                            Tradelink, admin dashboard and product website.
                        </p>
                    </p>
                </li>
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/company/arista-networks-inc/"
                        style={{ borderBottomWidth: 0.5 }}
                        className="font-semibold transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        Arista Networks
                    </a>

                    <p className="mt-3 text-base tracking-normal lg:mt-6">
                        <span className="font-bold">Tenure: </span>
                        May '22 - July '22
                        <br />
                        <span className="font-bold">Role: </span>
                        SDE Intern
                        <br />
                        <span className="font-bold">Tech Stack: </span>
                        Backend - GoLang
                        <p className="mt-3">
                            Working on backend tasks in the CloudVision team.
                        </p>
                    </p>
                </li>
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://stratzy.in/"
                        style={{ borderBottomWidth: 0.5 }}
                        className="font-semibold transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        Stratzy
                    </a>

                    <p className="mt-3 text-base tracking-normal lg:mt-6">
                        <span className="font-bold">Tenure: </span>
                        June '21 - Apr '22
                        <br />
                        <span className="font-bold">Role: </span>
                        Full Stack Developer
                        <br />
                        <span className="font-bold">Tech Stack: </span>
                        MERN - MongoDB, Express, React, Node
                        <p className="mt-3">
                            Working on the product and admin dashboard - Adding
                            features, making layouts, fixing bugs, etc
                        </p>
                    </p>
                </li>
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://caarya.in/"
                        style={{ borderBottomWidth: 0.5 }}
                        className="font-semibold transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        The Caarya Experience
                    </a>

                    <p className="mt-3 text-base tracking-normal lg:mt-6">
                        <span className="font-bold">Tenure: </span>
                        Oct '20 - Apr'21
                        <br />
                        <span className="font-bold">Role: </span>
                        Consultant – Front End Development
                        <br />
                        <span className="font-bold">Tech Stack: </span>
                        React, React Native (Expo)
                        <p className="mt-3">
                            Making responsive layouts for web and mobile
                            applications, working with various APIs and backend
                            integration.
                        </p>
                    </p>
                </li>
                <li>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.linkedin.com/company/naaniz/"
                        style={{ borderBottomWidth: 0.5 }}
                        className="font-semibold transition duration-300 ease-in-out border-dotted hover:border-transparent"
                    >
                        Naaniz
                    </a>

                    <p className="mt-3 text-base tracking-normal lg:mt-6">
                        <span className="font-bold">Tenure: </span>
                        Apr '20 - May '20
                        <br />
                        <span className="font-bold">Role: </span>
                        Android Developer
                        <br />
                        <span className="font-bold">Tech Stack: </span>
                        Android, Firebase
                        <p className="mt-3">
                            Worked on the Naaniz Mobile App.
                            <br />
                            (Layouts + APIs + Backend Integration)
                        </p>
                    </p>
                </li>
            </ul>
        </Card>
    );
};

export default Experience;
